module.exports = __webpack_public_path__ + "static/media/less-icon.d34363db.svg";